module.exports = __webpack_public_path__ + "img/00008.88dc00df.webp";